import * as pdfMakeUtils from 'pages/Ticket/Detail/components/DetailTab/pdfMakeUtils';

type Props = {
  data: { [key: string]: unknown }[];
  headers: { label: string; key: string; width: number }[];
  widthLength?: number;
  pageSize?: string;
  width?: string | number;
  isLandscape?: boolean;
};

const PDFTemplateClient = ({
  data,
  headers,
  widthLength,
  pageSize = 'A2',
  isLandscape = false
}: Props) => {
  const keys = headers?.map(
    (header: { label: string; key: string }) => header?.key
  );

  const headersText = headers?.map(
    (header: { label: string; key: string }) => header?.label
  );

  const bodyText = data?.map((row: any) =>
    keys?.map((key: string) => ({ text: row?.[key] || ' - ' }))
  );
  const content = {
    pageSize: isLandscape ? 'A1' : pageSize || 'A4',
    pageMargins: [10, 10, 10, 10],
    pageOrientation: isLandscape ? 'landscape' : 'portrait',
    defaultStyle: pdfMakeUtils.customTheme.defaultStyle,
    content: [
      {
        table: {
          widths:
            headers.map((item) => (item.width ? item.width : 'auto')) ||
            pdfMakeUtils.calculateWidths(widthLength),
          headerRows: 1,
          body: [
            headersText.map((item: string) => ({
              text: item,
              style: 'header'
            })),
            ...bodyText
          ]
        },
        layout: 'borderedContainer'
      }
    ],
    styles: {
      header: {
        fillColor: '#0A4A92',
        color: '#FFFFFF',
        bold: true
      }
    }
  };

  return content;
};

export default PDFTemplateClient;
